var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreActionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 23,
    viewBox: "0 0 5 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M2.51773 5.80859C1.80509 5.80859 1.20738 5.56887 0.724626 5.08942C0.241868 4.60996 0.000488281 4.01636 0.000488281 3.30859C0.000488281 2.60083 0.241868 2.00722 0.724626 1.52777C1.20738 1.04832 1.80509 0.808594 2.51773 0.808594C3.20738 0.808594 3.79359 1.04832 4.27635 1.52777C4.75911 2.00722 5.00049 2.60083 5.00049 3.30859C5.00049 4.01636 4.75911 4.60996 4.27635 5.08942C3.79359 5.56887 3.20738 5.80859 2.51773 5.80859Z",
    fill: "#475569"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M2.51773 14.0508C1.80509 14.0508 1.20738 13.8111 0.724626 13.3316C0.241868 12.8522 0.000488281 12.2585 0.000488281 11.5508C0.000488281 10.843 0.241868 10.2494 0.724626 9.76996C1.20738 9.2905 1.80509 9.05078 2.51773 9.05078C3.20738 9.05078 3.79359 9.2905 4.27635 9.76996C4.75911 10.2494 5.00049 10.843 5.00049 11.5508C5.00049 12.2585 4.75911 12.8522 4.27635 13.3316C3.79359 13.8111 3.20738 14.0508 2.51773 14.0508Z",
    fill: "#475569"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M2.51773 22.2969C1.80509 22.2969 1.20738 22.0572 0.724626 21.5777C0.241868 21.0982 0.000488281 20.5046 0.000488281 19.7969C0.000488281 19.0891 0.241868 18.4955 0.724626 18.0161C1.20738 17.5366 1.80509 17.2969 2.51773 17.2969C3.20738 17.2969 3.79359 17.5366 4.27635 18.0161C4.75911 18.4955 5.00049 19.0891 5.00049 19.7969C5.00049 20.5046 4.75911 21.0982 4.27635 21.5777C3.79359 22.0572 3.20738 22.2969 2.51773 22.2969Z",
    fill: "#475569"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreActionIcon);
export default __webpack_public_path__ + "static/media/MoreActionIcon.df19be5b229c5d7eb570840e198cf0b2.svg";
export { ForwardRef as ReactComponent };